import { render, staticRenderFns } from "./InformationDrawing.vue?vue&type=template&id=5a6f87dd&"
import script from "./InformationDrawing.vue?vue&type=script&lang=js&"
export * from "./InformationDrawing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports